<template>
	<div class="container mt-5">
		<div class="columns is-multiline is-justify-content-center">
			<add-card v-if="auth.state.isLoggedIn" column-class="column is-2" @click="openAdd"></add-card>
			<template v-for="(n, j) in gallerySearch" :key="j">
				<div class="column is-2 is-flex is-align-items-center is-justify-content-center my-5 is-relative">
					<div class="is-flex is-flex-direction-column is-justify-content-center is-align-items-center">
						<RouterLink :to="`/gallery/${n.name}`">
							<div class="rounded">
								<span class="icon is-large">
									<i class="far fa-2x fa-folder-open"></i>
								</span>
							</div>
						</RouterLink>
						<strong>
							{{ n.name }}
						</strong>
					</div>
					<div class="admin-actions" v-if="n.id && auth.state.isLoggedIn">
						<button class="icon-button" title="Edit" @click="openEdit(n)">
							<i class="fas fa-pen"></i>
						</button>
						<button class="icon-button icon-button-delete" title="Delete" @click="onDelete(n)">
							<i class="fas fa-trash"></i>
						</button>
					</div>
				</div>
			</template>
		</div>
	</div>
	<add-gallery-modal :show="showAddModal" :editing-item="editingItem" :on-submit="handleSubmit" @close="onModalClose"></add-gallery-modal>
</template>

<script>
import GALLERY from '@/gallery';
import AddCard from '@/components/AddCard.vue';
import AddGalleryModal from '@/components/AddGalleryModal.vue';
import auth from '@/auth.js';
import customItems from '@/customItems.js';
export default {
	name: 'GalleryView',
	props: ['modelValue'],
	components: { AddCard, AddGalleryModal },
	data() {
		return {
			auth,
			showAddModal: false,
			editingItem: null,
		};
	},
	computed: {
		gallery() {
			return [...customItems.getItems('gallery'), ...GALLERY];
		},
		gallerySearch() {
			return this.gallery.filter((g) => g.name.toLocaleLowerCase().includes(this.modelValue.toLocaleLowerCase()));
		},
	},
	methods: {
		openAdd() {
			this.editingItem = null;
			this.showAddModal = true;
		},
		openEdit(item) {
			this.editingItem = item;
			this.showAddModal = true;
		},
		onModalClose() {
			this.showAddModal = false;
			this.editingItem = null;
		},
		async handleSubmit({ isEdit, id, payload }) {
			if (isEdit) {
				return customItems.updateItem('gallery', id, payload);
			}
			return customItems.addItem('gallery', payload);
		},
		async onDelete(item) {
			if (!confirm(`Delete folder "${item.name}"?`)) return;
			const result = await customItems.deleteItem('gallery', item.id);
			if (!result.ok) {
				alert(result.error || 'Could not delete this folder.');
			}
		},
	},
};
</script>

<style scoped>
.icon {
	color: white;
}
.rounded {
	background-color: teal;
	border: 2px solid teal;
	border-radius: 10%;
	padding: 30px;
	margin-bottom: 1rem;
	cursor: pointer;
}

.rounded:hover {
	background-color: transparent;
	border-color: teal;
}
.rounded:hover .icon {
	color: teal;
}
.admin-actions {
	position: absolute;
	top: 6px;
	right: 6px;
	z-index: 20;
	display: flex;
	gap: 6px;
}
.icon-button {
	width: 26px;
	height: 26px;
	padding: 0;
	margin: 0;
	border: none;
	border-radius: 50%;
	background-color: rgba(0, 0, 0, 0.6);
	color: white;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 0.7rem;
}
.icon-button:hover {
	background-color: #48c78e;
	color: #131417;
}
.icon-button-delete:hover {
	background-color: #f14668;
	color: white;
}
</style>
